@if (showGallery) {
  <div class="bg-themeBlackTwo lg:pt-20.5 lg:pb-40 pt-15.5 pb-25">
    <div class="container">
      <div class="grid gap-4 place-items-center">
        <div #heroSection class="lg:max-w-217.75 w-full max-w-full min-w-0 text-center">
          <h1
            class="text-white font-bold lg:text-[42px] text-[28px] lg:leading-13.5 leading-normal lg:mb-3.5 mb-2 lg:tracking-[-1.47px] tracking-normal"
          >
            Discover, Download, Design
            <span class="md:block inline"> A Marketplace for Creative Assets</span>
          </h1>
          <p
            class="font-normal lg:text-lg text-[12px] lg:leading-7 leading-4 text-themeDimGray lg:mb-8.25 mb-0"
          >
            Exclusive Collection of SVGs, Icons, Illustrations, 3D Graphics, and Lottie Animations
          </p>

          <!------- Header Search Start ------->
          <div class="relative w-full lg:w-217.5 lg:block hidden">
            <div
              class="flex items-center justify-between relative w-full z-20 gap-2 shrink bg-white border border-[#EFEFF1] rounded-full"
            >
              <div class="inline-flex grow">
                <div class="relative inline-block border-r border-[#EFEFF1]">
                  <button
                    aria-label="Open menu"
                    class="text-[#101010] lg:ps-7 ps-4 lg:py-5.75 py-4 pe-3 font-Inter font-medium lg:text-base text-xs lg:leading-5 flex items-center"
                    (click)="toggleDropdown2('heroSearch', $event)"
                  >
                    <span class="truncate lg:max-w-20 max-w-13.25">{{ categorySelected }}</span>
                    <span>
                      <img
                        src="../../../../../assets/header/icons/arrow-down.svg"
                        class="transition-transform duration-200 lg:ms-2 ms-1.5 lg:size-5 size-4.5"
                        [ngClass]="{ 'rotate-180': isDropdownVisible('heroSearch') }"
                        alt="arrow down New Creative Stall"
                    /></span>
                  </button>
                  <!-- assets dropdown start  -->
                  <div
                    class="absolute left-0 top-16.25 w-45 overflow-hidden rounded-2xl bg-white shadow-lg ease-in-out duration-200 opacity-0 z-40"
                    [ngClass]="
                      isDropdownVisible('heroSearch')
                        ? 'opacity-100 translate-y-0 visible'
                        : 'translate-y-7 invisible'
                    "
                  >
                    <ul class="border-b border-gray-300 py-4.5 pb- px-1.5 flex flex-col gap-2">
                      <li class="cursor-pointer" (click)="onSelectCategory('All Assets')">
                        <span class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA]">
                          <img
                            class="size-4.5"
                            src="../../../../../assets/theme/images/logo/following.svg"
                            alt="Following"
                          />
                          <span class="font-semibold text-sm leading-5 text-themeNero"
                            >All Assets</span
                          ></span
                        >
                      </li>
                      @for (item of categories; track $index) {
                        <li (click)="onSelectCategory(item.name!)">
                          <a
                            class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA] cursor-pointer"
                          >
                            <img
                              class="size-4.5"
                              [src]="
                                '../../../../../assets/header/icons/' +
                                (item.menuName ?? 'default') +
                                '.svg'
                              "
                              alt="Popular"
                            /><span class="font-semibold text-sm leading-5 text-themeNero">{{
                              item.name
                            }}</span></a
                          >
                        </li>
                      }
                    </ul>
                    <div class="p-4.25 flex flex-col gap-2">
                      <div
                        class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA] cursor-pointer"
                      >
                        <input
                          [checked]="content === 'free'"
                          (click)="onSelectLicenseType('free')"
                          type="checkbox"
                          class="size-4.5 border border-[#0000000D] accent-themeNero"
                          id="hero-free"
                        />
                        <label for="hero-free" class="font-semibold text-sm leading-5 text-themeNero"
                          >Free</label
                        >
                      </div>
                      <div
                        class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA] cursor-pointer"
                      >
                        <input
                          [checked]="content === 'pro'"
                          (click)="onSelectLicenseType('pro')"
                          type="checkbox"
                          class="size-4.5 border border-[#0000000D] accent-themeNero"
                          id="hero-premium"
                        />
                        <label for="hero-premium" class="font-semibold text-sm leading-5 text-themeNero"
                          >Pro</label
                        >
                      </div>
                    </div>
                  </div>
                  <!-- assets dropdown end  -->
                </div>

                <input
                  type="search"
                  aria-label="Search creative assets"
                  placeholder="What are you looking for?"
                  [(ngModel)]="search"
                  (click)="isSearchOpen = !isSearchOpen"
                  (keydown)="handleKeyDown($event)"
                  (keyup.enter)="changeSearch($event)"
                  (input)="getliveSearch($event)"
                  (paste)="handlePaste($event)"
                  autocomplete="off"
                  maxlength="250"
                  class="grow lg:ps-3.5 ps-2 lg:py-5.75 py-4 font-normal lg:text-base text-xs lg:leading-5 text-[#878787] focus-within:outline-none"
                />
              </div>
              <!-- search action buttons start  -->
              <div class="inline-flex items-center gap-0 lg:pe-4 pe-3">
                @if (search.trim().length >= 1) {
                  <span class="p-1 shrink-0 cursor-pointer mr-2">
                    <img src="../../../../../assets/header/icons/cross-black.svg" alt="cross black"
                  /></span>
                }
                <button
                  aria-label="Search"
                  (click)="OnEnterSearch()"
                  class="group flex items-center justify-center lg:size-8 te-size-5 rounded-full hover:bg-black m-1 shrink-0 transition-colors duration-300"
                >
                  <img
                    src="../../../../../assets/header/icons/search-black.svg"
                    class="lg:size-5 size-4 block group-hover:hidden transition-opacity duration-300"
                    alt="search black"
                  />
                  <img
                    src="../../../../../assets/header/icons/search-white.svg"
                    class="lg:size-5 size-4 hidden group-hover:block transition-opacity duration-300"
                    alt="search white"
                  />
                </button>
                <!-- <button class="group flex items-center
             justify-center lg:size-8 te-size-5 rounded-full hover:bg-black
             m-1 shrink-0 transition-colors duration-300">
        <img src="../../../../../assets/header/icons/gallery-black.svg"
          class="lg:size-5 size-4 block group-hover:hidden transition-opacity duration-300" alt="search" />
        <img src="../../../../../assets/header/icons/gallery-white.svg"
          class="lg:size-5 size-4 hidden group-hover:block transition-opacity duration-300" alt="search white" />
      </button> -->
              </div>
              <!-- search action buttons end  -->
            </div>
            <!-- Backdrop -->
            <div
              *ngIf="isSearchOpen"
              class="fixed inset-0 bg-black/20 backdrop-blur-sm z-10"
              (click)="isSearchOpen = false"
            ></div>
            <div
              *ngIf="isSearchOpen"
              (click)="getTopSearchANDViews(); $event.stopPropagation()"
              class="absolute left-0 top-full -mt-8.75 bg-white z-10 rounded-br-3xl rounded-bl-3xl rounded-tr-lg rounded-tl-lg divide-y divide-themeWhiteSmoke shadow-md transition-all duration-300 ease-in-out opacity-0 animate-[fadeIn_0.3s_ease-in-out_forwards] w-full max-w-full overflow-hidden"
            >
              <div
                class="overflow-y-auto max-h-111.5 pt-14 pb-4"
                style="-webkit-overflow-scrolling: touch"
              >
                @if (liveSearch.length) {
                  @for (liveitem of liveSearch; let i = $index; track $index) {
                    <a
                      (click)="navigateToAssetGallery(liveitem)"
                      [ngClass]="{
                        'bg-gray-100': activeIndex === i,
                      }"
                      class="text-start block px-8 py-3 cursor-pointer hover:bg-themeWhiteSmoke"
                    >
                      {{ liveitem }}
                    </a>
                  }
                } @else {
                  @for (item of topSearchKeywords; let i = $index; track $index) {
                    <a
                      (click)="navigateToAssetGallery(item.searchKeyword)"
                      [ngClass]="{
                        'bg-gray-100': activeIndex === i,
                      }"
                      class="text-start block px-8 py-3 cursor-pointer hover:bg-themeWhiteSmoke"
                    >
                      {{ item.searchKeyword }}
                    </a>
                  }
                }

                <!-- <div>
                <h3 class="text-[#1D1D1D] font-medium leading-5 mb-4 text-left -top-5">Popular Search
                </h3>
                <div class="flex justify-start items-center gap-5 flex-wrap pb-6">
                  @for (item of topSearchsKeywords; track $index) {

                  <div class="bg-[#F5F5F5] px-5 py-2.5 rounded-md">
                    <a [routerLink]="getAssetGalleryPathWithParams(item.searchKeyword)" [queryParams]="{content: 'all'}"
                      class="font-medium text-base leading-normal text-[#121212]">{{item.searchKeyword}}</a>
                  </div>
                  }
                </div>
              </div>
              @if(topSearch.length){
              <div>
                <p class="text-[#1D1D1D] font-medium leading-5 mb-4 text-left pt-5">Recent Search</p>
                <div class="flex justify-start items-center gap-5 flex-wrap pb-6">
                  @for (itemsearch of topSearch; track $index) {
                  <div
                    class="bg-[#F5F5F5] px-5 py-2.5 rounded-md flex gap-2.5 justify-between items-center">
                    <a [routerLink]="getAssetGalleryPathWithParams(itemsearch.search)" [queryParams]="{content: 'all'}"
                      class="font-medium text-base leading-normal text-[#121212]">{{itemsearch.search}}</a>
                    <img (click)="deleteSearch(itemsearch.search)"
                      src="../../../../../assets/images/recenr-search-cross.svg" alt="recenr"
                      class="cursor-pointer size-4">
                  </div>
                  }
                </div>
              </div>
              }
              @if(iconPackDetail.length){
              <div>
                <p class="text-[#1D1D1D] font-medium leading-5 mb-4 text-left pt-5">Recent Viewed</p>
                <div class="flex justify-start items-center gap-5 flex-wrap pb-6">
                  @for (iconDetail of iconPackDetail; track $index) {

                  <a [routerLink]="getAssetGalleryPathWithParams(getFirstKeyword(iconDetail),iconDetail.categoryName!)"
                    [queryParams]="{content: 'all',detail:iconDetail.iconPackDetailID}"
                    class="bg-[#F5F5F5] px-5 py-2.5 rounded-md flex gap-2.5 justify-between items-center cursor-pointer">
                    <img loading="lazy" [src]="iconDetail.filePathPreview! | blobUrl" alt="filePath"
                      class="size-[38px] overflow-hidden">
                    <span
                      class="font-medium text-base leading-normal text-[#121212]">{{iconDetail.title}}</span>
                  </a>
                  }
                </div>
              </div>
              } -->
              </div>
            </div>
          </div>
          <!------- Header Search End ------->

          <!-- w-full + min-w-0 (not 100vw) so parent padding isn't blown past; nowrap + overflow-x for one-row scroll -->
          <div class="w-full max-w-full min-w-0 overflow-x-auto no-scrollbar">
            <ul
              class="flex flex-nowrap justify-center gap-1 w-max max-w-none mx-auto lg:mt-8 mt-4 text-themeSuvaGrey text-xs font-medium font-Inter"
            >
              @if (keywordsLoading) {
                @for (item of galleryLayoutService.skeletonLoaderItems(topSearchKeywords.length); track $index) {
                  <li class="shrink-0">
                    <ngx-skeleton-loader
                      count="1"
                      appearance="line"
                      class="inline-block shrink-0 w-16 h-6.5 rounded-[5px]"
                    ></ngx-skeleton-loader>
                  </li>
                }
              } @else {
                @for (item of topSearchKeywords; track $index) {
                  <li class="shrink-0">
                    <a
                      [routerLink]="getAssetGalleryPathWithParams(item.searchKeyword)" [queryParams]="getAssetGalleryQueryParams()"
                      class="bg-themeNeroTwo py-1.25 px-2.5 rounded-[5px] inline-block whitespace-nowrap"
                      >{{ item.searchKeyword }}</a
                    >
                  </li>
                }
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="xl:-mt-16 -mt-16 lg:px-26 px-5">
    <!-- Same markup for server and client: a CSS scroll-snap strip below xl, a 5-column grid from xl up. -->
    <div
      #cardsStrip
      class="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar xl:grid xl:grid-cols-5 xl:gap-4 xl:overflow-visible visual-cards"
      (scroll)="onCardsScroll()"
    >
      @if (categoryLoading) {
        @for (item of galleryLayoutService.skeletonLoaderItems(5); track $index) {
          <!-- Same height as the real cards (267px phone, 276px tablet) so the page below does not jump.
               From xl the real image scales with the card width, so the skeleton reserves the same text block plus an image-shaped box. -->
          <div class="bg-white rounded-lg shadow p-6 shrink-0 w-full md:w-1/2 snap-start xl:w-auto xl:p-0 min-h-66.75 md:min-h-69 xl:min-h-0">
            <div class="xl:p-6 xl:h-24.25">
              <div class="w-2/3 h-6 bg-gray-200 rounded mb-2 animate-pulse"></div>
              <div class="w-full h-10 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div class="hidden xl:block w-full aspect-[990/582]"></div>
          </div>
        }
      } @else {
        @for (item of categories; track $index) {
          <div class="shrink-0 w-full md:w-1/2 snap-start px-0.5 xl:w-auto xl:px-0">
            <div
              class="rounded-xl cursor-pointer flex justify-between flex-col h-full xl:hover:scale-[1.04] transition-all duration-300 ease-in-out"
              (click)="goToPack(item.name!)"
              (mousedown)="openInNewTab($event, item.name!)"
              [ngStyle]="{ 'background-color': colors[$index] || '#FFE6FF' }"
            >
              <div class="lg:px-7.5 px-5 lg:pt-6.75 pt-5 pb-0 w-full">
                <p class="font-Inter font-bold text-themeNeroThree text-base leading-5 mb-1">
                  {{ item.name }}
                </p>
                <p class="font-Inter font-normal text-[#878787] text-sm">
                  {{ item.shortDescription }}
                </p>
              </div>
              <div class="flex justify-center items-end" [ngClass]="paddingClasses[$index]">
                @if (item.iconCategoryCard?.endsWith('.json')) {
<!--                  <app-lottie-card-->
<!--                    [filepath]="appendBlobSasToken(item.iconCategoryCard, null)"-->
<!--                    [alwaysPlay]="false"-->
<!--                    [defaultHeight]="false"-->
<!--                    class="block aspect-[225/194] xl:w-[70%] lg:w-full w-[65%] [@media(min-width:2500px)]:object-contain [@media(min-width:2500px)]:h-auto"-->
<!--                  ></app-lottie-card>-->
                  <img
                    class="block aspect-[225/194] xl:w-[70%] lg:w-full w-[65%] [@media(min-width:2500px)]:object-contain [@media(min-width:2500px)]:h-auto"
                    [src]="'assets/theme/lottie/animation.webp'"
                    alt="{{ item.name }} preview image"
                   width="990"
                    height="582"
                  />
                } @else {
                  <img
                    class="w-full h-auto max-h-87.5 object-contain object-bottom"
                    [src]="appendBlobSasToken(item.iconCategoryCard, null)"
                    alt="{{ item.name }} preview image"
                    width="990"
                    height="582"
                  />
                }
              </div>
            </div>
          </div>
        }
      }
    </div>
    <!-- Pagination dots (below xl only) -->
    <!-- Fixed height so the dots appearing after load do not push the content below. -->
    <!-- Each button has a 26px+ tap area; negative margins keep the dots visually 8px apart. -->
    <div class="flex justify-center items-center mt-3 h-2 xl:hidden">
      @if (!categoryLoading && categories.length > 1) {
        @for (page of cardDots; track page) {
          <button
            type="button"
            class="p-2.5 -mx-1.5"
            [attr.aria-label]="'Show page ' + (page + 1)"
            (click)="scrollToCard(page)"
          >
            <span
              class="block rounded-full transition-all"
              [ngClass]="activeCardIndex === page ? 'size-2 bg-[#121212]' : 'size-1.5 bg-[#d6d6d6]'"
            ></span>
          </button>
        }
      }
    </div>
  </div>
  <!-- <app-lottie-card [filepath]="'../../../../../assets/landing-page/data2.json'" [alwaysPlay]="true" [defaultHeight]="false" class="size-20"></app-lottie-card> -->
  <!-- <img src="../../../../../assets/landing-page/25.lottie" alt=""> -->
  <!-- <ng-lottie
  [options]="options"
  style="width: 100%; height: 194px;"
></ng-lottie> -->

  <div class="lg:px-26 px-5 lg:pb-30 pb-10">
    @if (loading) {
      <div *ngFor="let item of galleryLayoutService.skeletonLoaderItems(3)" class="lg:pt-25 pt-10">
        <div class="flex justify-between mb-6">
          <div class="lg:w-60 w-28 h-6 bg-gray-200 rounded animate-pulse"></div>
          <div class="lg:w-60 w-28 h-6 bg-gray-200 rounded animate-pulse"></div>
        </div>
        <div
          #packGrid
          class="w-full flex flex-nowrap overflow-x-auto gap-3 hide-scrollbar md:gap-x-4 md:gap-y-6 lg:grid lg:grid-flow-row lg:grid-rows-1 lg:overflow-x-hidden lg:gap-x-4 lg:gap-y-6 lg:grid-cols-[repeat(auto-fill,minmax(310px,1fr))]"
        >
          <app-pack-card-loader
            class="contents"
            [loaderCount]="packSkeletonLoaderCount()"
            [rowCellClass]="packSkeletonRowCellClass"
          ></app-pack-card-loader>
        </div>
      </div>
    } @else {
      @for (item of packCategories; track $index) {
        @if (item.iconPacks.length) {
          <div class="lg:pt-17.5 pt-10">
            <div class="flex justify-between mb-6">
              <p class="font-Inter font-bold text-2xl text-themeBlackTwo">
                {{ item.category.name }}
              </p>
              <a
                [routerLink]="getPackGalleryPath(item.category)"
                class="font-Inter font-medium text-base text-themeBlackTwo flex items-center cursor-pointer hover:underline"
                >Explore
                <span class="lg:block hidden ms-1">{{ item.category.name }}</span>
                <img
                  src="../../../../../assets/theme/images/icons/arrow-right.svg"
                  class="ms-1"
                  alt="Go to {{ item.category.name }} category"
              /></a>
            </div>
            <div
              #packGrid
              class="w-full flex flex-nowrap overflow-x-auto gap-3 hide-scrollbar md:gap-x-4 md:gap-y-6 lg:grid lg:grid-flow-row lg:grid-rows-1 lg:overflow-x-hidden lg:gap-x-4 lg:gap-y-6 lg:grid-cols-[repeat(auto-fill,minmax(310px,1fr))]"
            >
              @for (packItem of visiblePacks(item.iconPacks); track packItem.iconPackID) {
                <div class="w-77.5 shrink-0 min-width-mobile lg:w-full lg:min-w-0 lg:max-w-none">
                  <app-pack-card
                    class="block h-full w-full"
                    [token]="token"
                    [categories]="categories"
                    [pack]="packItem"
                    [categoryInfo]="item.category"
                  ></app-pack-card>
                </div>
              }
            </div>
          </div>
        }
      }
    }
  </div>
}

<!-- CTA banner Start  -->
<div class="lg:px-26 px-5 lg:pb-30 pb-12.5 landing-cta-banner">
  <div
    class="bg-[#FECB2F] rounded-2xl flex justify-between lg:gap-2 gap-2.5 lg:flex-row flex-col overflow-hidden"
  >
    <div
      class="2xl:py-17.25 xl:py-15.5 lg:py-11 py-7.5 2xl:ps-22.25 xl:ps-15 lg:ps-11 ps-7.5 lg:pe-0 pe-7.5"
    >
      <div class="2xl:max-w-157.75 xl:max-w-82.5 lg:max-w-83.5 max-w-full">
        <h2
          class="font-bold 2xl:text-[42px] xl:text-[36px] text-[24px] 2xl:leading-13.5 xl:leading-11.25 leading-normal 2xl:mb-4 xl:mb-3 mb-2 text-[#101010] tracking-normal"
        >
          Unlock Unlimited Creative Assets for your Projects
        </h2>
        <p
          class="font-normal 2xl:text-xl xl:text-[18px] text-[14px] 2xl:leading-7 xl:leading-6.75 leading-5 2xl:mb-7.5 xl:mb-6 mb-5 text-[#404040] tracking-normal"
        >
          Explore a wide collection of creative assets designed to speed up your workflow and
          enhance your projects.
        </p>
        @if (subscribedPackage) {
          <a
            [routerLink]="isUserLogin ? '/profile/pricing' : '/pricing'"
            class="rounded-full font-medium text-white bg-[#202020] 2xl:py-3 2xl:px-6 2xl:text-base 2xl:leading-6 xl:py-3 xl:px-6 xl:text-base lg:py-2.5 lg:px-5 lg:text-sm py-2.5 px-5 text-sm text-nowrap"
          >
            Get Unlimited Downloads
          </a>
        }
      </div>
    </div>
    <div class="pe-0">
      <picture>
        <source media="(min-width: 1536px)" srcset="../../../../../assets/landing-page/CTA-banner-yelow-bg-v2.png" width="797" height="400">
        <source media="(min-width: 1280px)" srcset="../../../../../assets/CTA-banner-images/unlock-unlimited-mid-v2.png" width="637" height="356">
        <source media="(min-width: 1024px)" srcset="../../../../../assets/CTA-banner-images/unlock-unlimited-tablet-v2.png" width="423" height="250">
        <img
          loading="lazy" decoding="async"
          width="335" height="267"
          src="../../../../../assets/CTA-banner-images/CTA-banner-yelow-bg-mob-v2.png"
          alt="Unlock Unlimited Creative Assets for your Projects"
          class="w-full lg:h-full h-auto object-cover rounded-br-2xl rounded-bl-2xl"
        />
      </picture>
    </div>
  </div>
</div>
<!-- CTA banner end  -->

<!-- Calendar of Festivities start — same one-row / visibleCount rules as pack category rows -->
@if (isFestivitiesLoading) {
  <div class="lg:px-26 px-5 lg:pb-25 pb-12.5">
    <div class="flex justify-between items-center mb-6">
      <div class="lg:w-60 w-28 h-6 bg-gray-200 rounded animate-pulse"></div>
      <div class="lg:w-60 w-28 h-6 bg-gray-200 rounded animate-pulse"></div>
    </div>
    <div
      #festivityGrid
      class="w-full flex flex-nowrap overflow-x-auto gap-3 hide-scrollbar md:gap-x-4 md:gap-y-6 lg:grid lg:grid-flow-row lg:grid-rows-1 lg:overflow-x-hidden lg:gap-x-4 lg:gap-y-6 lg:grid-cols-[repeat(auto-fill,minmax(310px,1fr))]"
    >
      @for (item of galleryLayoutService.skeletonLoaderItems(packSkeletonLoaderCount()); track $index) {
        <div [class]="packSkeletonRowCellClass">
          <div
            class="border border-themeWhisperTwo rounded-2xl pt-6 flex flex-col justify-between gap-14.25 h-112.5 overflow-hidden"
          >
            <div class="px-6">
              <div class="w-1/2 h-5 bg-gray-200 rounded animate-pulse mb-2"></div>
              <div class="w-3/4 h-3 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div
              class="w-full h-80.75 bg-gray-200 rounded-bl-2xl rounded-br-2xl animate-pulse"
            ></div>
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  @for (items of parentFestivities; track items.eventCategoryID) {
    @if (items.children?.length) {
      <div class="lg:px-26 px-5 lg:pb-25 pb-12.5">
        <div class="flex justify-between items-center mb-6">
          <h3 class="font-bold text-2xl leading-normal text-[#101010]">{{ items.eventName }}</h3>
          <a
            [routerLink]="['festivities', getname(items.eventName)]"
            class="font-Inter font-medium text-base leading-5 text-themeBlackTwo flex items-center cursor-pointer hover:underline"
            >Explore
            <span class="lg:block hidden ms-1">{{ items.eventName }}</span>
            <img
              src="../../../../../assets/theme/images/icons/arrow-right.svg"
              class="ms-1"
              alt="Go to {{ items.eventName }} category"
          /></a>
        </div>
        <div
          #festivityGrid
          class="w-full flex flex-nowrap overflow-x-auto gap-3 hide-scrollbar md:gap-x-4 md:gap-y-6 lg:grid lg:grid-flow-row lg:grid-rows-1 lg:overflow-x-hidden lg:gap-x-4 lg:gap-y-6 lg:grid-cols-[repeat(auto-fill,minmax(310px,1fr))]"
        >
          @for (item of visibleFestivityChildren(items.children); track item.eventCategoryID) {
            <div class="w-77.5 shrink-0 min-width-mobile lg:w-full lg:min-w-0 lg:max-w-none">
              <div
                (click)="goToEventGallery(item.eventName)"
                class="h-full w-full min-w-0 overflow-hidden pt-6 border border-[#EFEFF1] rounded-2xl flex justify-between flex-col gap-14.25 cursor-pointer"
              >
                <div class="px-6 min-w-0">
                  <h4
                    class="font-bold lg:text-xl text-lg leading-normal text-[#101010] lg:mb-2 mb-1"
                  >
                    {{ item.eventName }}
                  </h4>
                  <p class="font-medium text-xs leading-normal text-[#636363]">
                    {{ item.description }}
                  </p>
                </div>
                <img
                  [src]="appendBlobSasToken(item.thumbnail, null)"
                  [alt]="item.eventName"
                  loading="lazy"
                  width="323"
                  height="323"
                  class="w-full max-w-full h-auto block rounded-2xl"
                />
              </div>
            </div>
          }
        </div>
      </div>
    }
  }
}
<!-- Calendar of Festivities end -->

<!-- CTA free downloads banner Start  -->
<div class="lg:px-26 px-5 lg:pb-25 pb-12.5 hidden">
  <div
    class="bg-[#FECB2F] rounded-2xl flex justify-between lg:gap-2 gap-11 xl:flex-row flex-col overflow-hidden"
  >
    <div class="py-17.25 ps-24">
      <div class="2xl:max-w-189.5 xl:max-w-137.5 max-w-full">
        <h2
          class="font-bold lg:text-[42px] text-[28px] lg:leading-13.5 mb-4 text-[#101010] tracking-normal"
        >
          Discover Thousands of Free Ready to Use Unique Assets
        </h2>
        <p class="font-normal lg:text-xl text-base leading-5 text-[#404040] mb-7.5 xl:pe-4 pe-0">
          Explore a vast collection of high-quality assets designed to speed up your workflow and
          elevate your designs.
        </p>
        @if (subscribedPackage) {
          <a
            [routerLink]="isUserLogin ? '/profile/pricing' : '/pricing'"
            class="rounded-full font-medium text-white bg-[#202020] 2xl:py-3 2xl:px-6 2xl:text-base 2xl:leading-6 xl:py-3 xl:px-6 xl:text-base lg:py-2.5 lg:px-5 lg:text-sm py-2.5 px-5 text-sm text-nowrap"
          >
            Get Freebies
          </a>
        }
      </div>
    </div>
    <div>
      <img
        loading="lazy" decoding="async"
        src="../../../../../assets/CTA-banner-images/free-download-img.svg"
        alt=" Discover Thousands of Free Ready to Use Unique Assets"
        class="w-full xl:h-full h-auto object-cover"
      />
    </div>
  </div>
</div>
<!-- CTA free downloads banner end  -->

<!-- CTA banner Start  -->
<div class="hidden 2xl:px-26 xl:px-10 lg:px-20 px-5 lg:pb-30 pb-12.5">
  <div
    class="bg-[#FECB2F] rounded-xl 2xl:px-16 2xl:pt-14 xl:px-10 xl:pt-10 lg:px-6 lg:pt-8 px-6 pt-10 flex 2xl:items-end 2xl:flex-row 2xl:gap-7.5 xl:justify-between xl:items-end xl:flex-row xl:gap-5 lg:flex-col lg:items-center lg:gap-0 flex-col items-center gap-0 w-full max-w-full overflow-hidden"
  >
    <!-- Left image — hidden below xl -->
    <img loading="lazy" decoding="async" src="../../../../../assets/images/CTA-img-1.svg" alt="CTA Image 1" class="shrink-0 hidden xl:block" />
    <!-- Centre content -->
    <div
      class="flex justify-center items-center flex-col shrink-0 2xl:pb-17 xl:flex-1 xl:max-w-157.75 xl:pb-12 lg:max-w-157.75 lg:pb-8 pb-8 lg:order-1 order-1"
    >
      <h3
        class="font-bold text-center text-[#101010] mb-4 2xl:text-[42px] 2xl:leading-13.5 xl:text-[32px] xl:leading-10.5 lg:text-[26px] lg:leading-8.5 text-[22px] leading-7.5 lg:mb-3"
      >
        Unlock Unlimited Creative Assets for your Projects
      </h3>
      <p
        class="font-normal text-[#404040] text-center 2xl:text-xl 2xl:leading-7 2xl:mb-8 xl:text-[17px] xl:leading-7 xl:mb-7 lg:text-[15px] lg:leading-6 lg:mb-6 text-sm leading-6 mb-6"
      >
        Explore a wide collection of creative assets designed to speed up your workflow and enhance
        your projects.
      </p>
      @if (subscribedPackage) {
        <a
          [routerLink]="isUserLogin ? '/profile/pricing' : '/pricing'"
          class="rounded-full font-medium text-white bg-[#202020] 2xl:py-3 2xl:px-6 2xl:text-base 2xl:leading-6 xl:py-3 xl:px-6 xl:text-base lg:py-2.5 lg:px-5 lg:text-sm py-2.5 px-5 text-sm text-nowrap"
        >
          Get Unlimited Downloads
        </a>
      }
    </div>
    <!-- Right robot image -->
    <img
      loading="lazy" decoding="async"
      src="../../../../../assets/images/CTA-img-2.svg"
      alt="CTA Creative Stall"
      class="shrink-0 xl:self-end lg:order-2 order-2 lg:w-[55%] lg:max-w-55 w-full max-w-55 xl:w-auto xl:max-w-none"
    />
  </div>
</div>
<!-- CTA banner end  -->

<app-browse-assets-by-keywords></app-browse-assets-by-keywords>
